const _mainMixins = {
  methods: {
    textElipsise (el) {
      if (el.scrollHeight <= el.offsetHeight) {
        return
      }
      let wordArray = el.innerText.split(' ')
      const wordsLength = wordArray.length
      let activeWord
      let activePhrase
      let isEllipsed = false
      for (let i = 0; i < wordsLength; i++) {
        if (el.scrollHeight > el.offsetHeight) {
          activeWord = wordArray.pop()
          el.innerText = activePhrase = wordArray.join(' ')
        } else {
          break
        }
      }
      let charsArray = activeWord.split('')
      const charsLength = charsArray.length
      for (let i = 0; i < charsLength; i++) {
        if (el.scrollHeight > el.offsetHeight) {
          charsArray.pop()
          el.innerText = activePhrase + ' ' + charsArray.join('') + '...'
          isEllipsed = true
        } else {
          break
        }
      }
      if (!isEllipsed) {
        activePhrase = el.innerText
        let phraseArr = activePhrase.split('')
        phraseArr = phraseArr.slice(0, phraseArr.length - 3)
        el.innerText = phraseArr.join('') + '...'
      }
    }
  }
}
export default _mainMixins



// WEBPACK FOOTER //
// ./src/helpers/_mixins.js